// Single source of truth for brand / contact / store links. Reused by the footer (01),
// header, and the SEO layer (05 — JSON-LD, OG, sitemap).
export const SITE = {
  name: "Nasiyah",
  domain: "https://nasiyah.uz",
  email: "support@nasiyah.uz",
  phone: "+998933852600",
  social: {
    telegram: "https://t.me/nasiyah_support",
    instagram: "https://instagram.com/nasiyah.uz",
  },
  stores: {
    appStore: "https://apps.apple.com/tr/app/nasiyah-bizness/id6747801255",
    googlePlay:
      "https://play.google.com/store/apps/details?id=mobile.app.nasiyah_merchant",
  },
} as const;

// SSG and network-failure fallbacks. The browser replaces these with the admin-managed
// public settings after hydration, while the page stays complete if the API is unavailable.
export const PUBLIC_SETTINGS_FALLBACK = {
  premiumPrice: "165000.00",
  freeTierMonths: 6,
  supportTelegramLink: SITE.social.telegram,
  supportPhone: SITE.phone,
} as const;

// In-page section anchors used by the header/footer nav (sections are built in 02–04).
export const NAV_SECTIONS = [
  { id: "features", key: "nav.features" },
  { id: "how", key: "nav.how" },
  { id: "pricing", key: "nav.pricing" },
  { id: "faq", key: "nav.faq" },
] as const;
